import styled, { css } from 'styled-components';
import { TrevorIcon } from '@trevor/ui-components';

export const ActivityExpandIcon = styled(TrevorIcon).attrs({
  name: 'chevron-down',
})<{ flip: boolean }>`
  transition: 0.3s;
  ${(p) =>
    p.flip &&
    css`
      rotate: z 180deg;
    `};
`;

export const ActivityContainer = styled.div`
  width: 100%;
  border-radius: var(--radius-8);

  border-left: var(--spacing-l) solid ${(p) => p.color};
  background: var(--color-interface-layout-lighter);

  &:hover {
    background: var(--color-interface-layout-lightest);
  }

  &:active {
    background: var(--color-interface-layout-lighter);
  }
`;
export const ActivityHeader = styled.div`
  padding: var(--spacing-xl) calc(var(--spacing-m) * 2);
  border-top-right-radius: inherit;
  border-bottom-right-radius: ${(p) =>
    p.hasBottomRightBorderRadius ? 'inherit' : 'unset'};
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  background: ${(p) => p.color};
  gap: var(--spacing-m);

  > p:last-of-type {
    margin-left: auto;
  }
`;
